import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import * as uuid from 'uuid';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { cpfValidator } from 'src/app/modules/shared/validators/cpf-validator';
import { phoneNumberValidator } from 'src/app/modules/shared/validators/phone-validator';
import { FormatUtilsService } from 'src/app/modules/services/format-utils/format-utils.service';

@Component({
  selector: 'app-modal-representante-legal',
  templateUrl: './modal-representante-legal.component.html',
  styleUrls: ['./modal-representante-legal.component.scss'],
})
export class ModalRepresentanteLegalComponent {
  @Input() isEditMode: boolean = false;
  @Input() data: any = {};
  form: FormGroup;
  status: boolean = true;
  id: any = null;
  tempId: any = null;
  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private modalCtrl: ModalController,
    private formatUtilsService: FormatUtilsService
  ) {
    this.form = this.fb.group({
      nomeCompleto: [null, [Validators.required]],
      cpf: ['', [Validators.required, cpfValidator()]],
      funcao: [null, [Validators.required]],
      telefone: [null, [Validators.required, phoneNumberValidator()]],
      email: [null, [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    if (this.isEditMode && this.data) {
      this.form.patchValue({
        nomeCompleto: this.data.nomeCompleto,
        cpf: this.formatUtilsService.formatCpf(this.data.cpf),
        funcao: this.data.funcao,
        telefone: this.formatUtilsService.formatPhoneNumber(this.data.telefone),
        email: this.data.email,
      });
      this.id = this.data.id;
      this.tempId = this.data.tempId;
    }
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  onSubmit() {
    const formValues = this.form.value;
    const id = this.isEditMode ? this.data.id : "";
    const tempId = this.isEditMode ? this.tempId : uuid.v1();

    const formattedObj = {
      id: id ,
      tempId: tempId,
      nomeCompleto: formValues.nomeCompleto,
      cpf: formValues.cpf,
      funcao: formValues.funcao,
      telefone: formValues.telefone,
      email: formValues.email,
    };
    

    const msg = this.isEditMode
      ? 'Representante legal editado com sucesso'
      : 'Representante legal inserido com sucesso';

    this.toastService.showSuccess(msg);
    return this.modalCtrl.dismiss(formattedObj, 'confirm');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
